import React from 'react';
import PropTypes from 'prop-types';
import ThankYouBox from './thankYouBox';
import VideoUpload from './videoUpload';
import InviteOthers from './inviteOthers';

const MainAppreciate = props => {
  let isLeader;
  let showVideoUpload = false;

  if (props.comment && props.comment.href) {
    isLeader = props.comment.href.includes('leader');
  }

  if (
    props.comment.program &&
    (props.comment.program.manager || props.comment.program.peer)
  ) {
    showVideoUpload = isLeader
      ? props.comment.program.manager && props.comment.program.manager.video
      : props.comment.program.peer && props.comment.program.peer.video;
  }

  return (
    <main>
      <ThankYouBox
        translations={props.translations}
        color={props.comment.program.color}
        allDoneClick={props.allDoneClick}
      />
      {(showVideoUpload ||
        (props.comment.invite && props.comment.invite.href)) && (
        <h3 className="site-width-h3">
          {props.translations['add-to-experience']}
        </h3>
      )}
      {showVideoUpload && <VideoUpload {...props} />}
      {props.comment.invite &&
        props.comment.invite.href && (
          <InviteOthers
            translations={props.translations}
            color={props.comment.program.color}
            inviteUrl={props.comment.invite.href}
            basePath={props.basePath}
            showVideoUpload={showVideoUpload}
          />
        )}
    </main>
  );
};

MainAppreciate.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  comment: PropTypes.shape({
    href: PropTypes.string,
    invite: PropTypes.shape({
      href: PropTypes.string,
    }),
    program: PropTypes.shape({
      color: PropTypes.string,
      peer: PropTypes.shape({
        video: PropTypes.bool,
      }),
      manager: PropTypes.shape({
        video: PropTypes.bool,
      }),
    }),
  }).isRequired,
  allDoneClick: PropTypes.func,
  submitVideo: PropTypes.func,
  videoUploadSuccessful: PropTypes.bool,
  basePath: PropTypes.string,
  videoFileName: PropTypes.string,
  captureFileName: PropTypes.func,
  spinnerDisplay: PropTypes.bool,
};

MainAppreciate.defaultProps = {
  allDoneClick: () => {},
  submitVideo: () => {},
  videoUploadSuccessful: false,
  basePath: '',
  videoFileName: '',
  captureFileName: () => {},
  spinnerDisplay: false,
};

export default MainAppreciate;
